import { useTranslation } from "react-i18next";
import { Markdown } from "../common/markdown";
import type { NewType } from "../../types/common";
import type { StrapiReturn } from "../../types/strapi-return";
import { getStrapiImageUrl } from "../../lib/get-strapi-image-url";
import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export function LatestNew({ data }: { data: StrapiReturn<NewType> }) {
	const { t } = useTranslation();
	const markdownRef = useRef<HTMLDivElement>(null);
	const [readMore, setReadMore] = useState(false);

	const { url, alternativeText } = data.attributes.image.data.attributes;

	let body = t(`news.${data.id}.body`);

	useEffect(() => {
		if (!markdownRef.current) {
			return;
		}

		const markdownElements = markdownRef.current.querySelectorAll("*");
		markdownElements.forEach((element, index) => {
			if (index > 4) {
				element.classList.add("hidden");
			} else {
				element.classList.remove("hidden");
			}
		});

		setReadMore(markdownElements.length > 5);
	}, [body]);

	return (
		<div className="flex flex-col md:flex-row items-center md:items-start gap-4">
			<div className="md:order-2 flex flex-col gap-4 flex-1">
				<h3 className="font-semibold text-[#002969] text-lg sm:text-xl md:text-2xl">
					{t(`news.${data.id}.title`)}
				</h3>

				<Markdown ref={markdownRef} className="[&_img]:hidden">
					{body}
				</Markdown>

				{readMore && (
					<div className="text-sm text-red-600">
						<NavLink to={`/aktualnosci/${data.id}`}>{t("news.read")}</NavLink>
					</div>
				)}
			</div>

			<div className="md:order-1 w-full max-w-sm">
				<div className="w-full h-0 pb-[80%] relative">
					<NavLink to={`/aktualnosci/${data.id}`}>
						<img
							src={getStrapiImageUrl(url)}
							alt={alternativeText}
							className="absolute top-0 left-0 w-full h-full object-contain rounded"
						/>
					</NavLink>
				</div>
			</div>
		</div>
	);
}
